import {
	Component,
	OnInit,
	Input,
	OnChanges,
	SimpleChanges
} from "@angular/core";
import { DecimalPipe } from "@angular/common";

@Component({
    selector: "total-value-display",
    templateUrl: "./total-value-display.component.html",
    styleUrls: ["./total-value-display.component.scss"],
    standalone: false
})
export class TotalValueDisplayComponent implements OnInit, OnChanges {
	_value: string;
	_negative = false;
	_percentage?: string;
	_priceWithoutDiscount: string;
	_totalCostAfterXMonths: string;

	@Input() set value(val: string) {
		if (val !== undefined && val !== null) {
			this._value = val;
		} else {
			this._negative = false;
			this._value = undefined;
		}
	}

	@Input() set priceWithoutDiscount(val: string) {
		if (val !== undefined && val !== null) {
			this._priceWithoutDiscount = val;
		} else {
			this._negative = false;
			this._priceWithoutDiscount = undefined;
		}
	}

	@Input() set totalCostAfterXMonths(val: string) {
		if (val !== undefined && val !== null) {
			this._totalCostAfterXMonths = val;
		} else {
			this._negative = false;
			this._totalCostAfterXMonths = undefined;
		}
	}

	@Input() currencySymbol = "$";

	constructor(private decimalPipe: DecimalPipe) {}

	ngOnInit() {}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes["currencySymbol"]) {
			if (
				this.currencySymbol === "%" ||
				this.currencySymbol === "percent"
			) {
				// this._value = this.decimalPipe.transform(this._value, "0.0-0");
				this._percentage = "%";
			}
		}
	}
}
